import React, { useState } from 'react';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];

export default function Calendar({ selectedDates, onToggleDate }) {
  const today = new Date();
  const [viewYear, setViewYear] = useState(today.getFullYear());
  const [viewMonth, setViewMonth] = useState(today.getMonth());

  const firstDay = new Date(viewYear, viewMonth, 1).getDay();
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
  const todayStr = formatDate(today);

  function formatDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  function goToPrev() {
    if (viewMonth === 0) {
      setViewMonth(11);
      setViewYear(y => y - 1);
    } else {
      setViewMonth(m => m - 1);
    }
  }

  function goToNext() {
    if (viewMonth === 11) {
      setViewMonth(0);
      setViewYear(y => y + 1);
    } else {
      setViewMonth(m => m + 1);
    }
  }

  const cells = [];

  // Empty cells before first day
  for (let i = 0; i < firstDay; i++) {
    cells.push(<div key={`empty-${i}`} className="calendar-day empty" />);
  }

  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${viewYear}-${String(viewMonth + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    const isPast = dateStr < todayStr;
    const isSelected = selectedDates.includes(dateStr);
    const isToday = dateStr === todayStr;

    let className = 'calendar-day';
    if (isPast) className += ' disabled';
    if (isSelected) className += ' selected';
    if (isToday) className += ' today';

    cells.push(
      <div
        key={dateStr}
        className={className}
        onClick={() => !isPast && onToggleDate(dateStr)}
        title={dateStr}
      >
        {d}
      </div>
    );
  }

  return (
    <div>
      <div className="calendar-nav">
        <button type="button" onClick={goToPrev} aria-label="Previous month">‹</button>
        <h3>{MONTHS[viewMonth]} {viewYear}</h3>
        <button type="button" onClick={goToNext} aria-label="Next month">›</button>
      </div>
      <div className="calendar-grid">
        {DAYS.map(d => <div key={d} className="calendar-header">{d}</div>)}
        {cells}
      </div>
    </div>
  );
}
